<template>
    <Alert v-if="alertContent || loadingMood" :loadingMood="loadingMood" :alertContent="alertContent" @confirm="handleConfirm" @close="alertContent=null"/>
    <div class="comment-form" v-if="slug">
            <div class="col-sm-12">
                <div class="form-group">
                    <textarea v-model="comment" placeholder="متن نظر" class="form-control" rows="4"></textarea>
                </div>
            </div>
            <button v-on:click="sendNewComment">افزودن نظر</button>
        </div>
</template>

<script>
    import  Alert from '../components/Alert'
    import axios from 'axios'
    export default {
        name: "CommentForm",
        data() {
            return {
                alertContent: null,
                loadingMood: false,
                comment:null
            }
        },
        props:['type','slug','parentId'],
        components:{
            Alert,
        },
        methods:{
            async sendNewComment(){
                try {
                    let checkSpace = this.comment.replace(/\s/g, "");
                    if(checkSpace !== ""){
                        this.loadingMood = true;
                        const formData = new FormData();
                        formData.append('slug', this.slug);
                        formData.append('parent_id', this.parentId);
                        formData.append('type', this.type);
                        formData.append('comment', this.comment);
                        let response = await axios.post('api/userDashboard/newCommentStore',formData,
                            {
                                headers:
                                    {
                                        "Authorization": `Bearer ${localStorage.getItem('token')}`,
                                    }
                            });
                        this.loadingMood = false;
                        this.comment = null;
                        console.log(response.data.message);
                        this.alertContent =
                            {
                                message: 'نظر شما با موفقیت ذخیره شد!',
                                notice:'',
                                imageUrl:require('../assets/new/New/Block.png'),
                                buttonType:'close',//close
                                buttonText:'تایید',
                                buttonLink:'',
                                waitingMode:false,
                                closeButtonShow:true
                            }
                    }
                } catch (error) {
                    console.log(error)
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    .text-field {
        position: relative;
        margin: 10px 2.5px 20px 2.5px;
    }
    #email-input{
        text-align: left;
        padding-right: 15px;
    }
    input:focus {
        border: thin solid #32cd32;
        border-bottom: solid medium #32cd32;
        background-color:#fff;
    }
    input:focus ~ label, input:valid ~ label {
        top: -12px;
        right: 15px;
        font-size: small;
        color:  #fe7063;
        padding:0 5px 0 5px;
        background-color: white;

    }
    input{
        text-align: right;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #162336;
        width: 300px;
        height: 40px;
        border-radius: 5px!important;
        border: solid 2px lightgray;
    }
    input:focus{
        border: solid 2px #fe7063!important;
    }
    *:focus {
        border: solid 0.5px #162336!important;
    }
   textarea:focus{
       border: solid 2px #fe7063!important;
   }
   textarea{
       text-align: right;
       font-size: 15px;
       font-weight: normal;
       font-stretch: normal;
       font-style: normal;
       line-height: normal;
       letter-spacing: normal;
       color: #162336;
       border-radius: 10px!important;
       border: solid 2px lightgray;
   }
    .form-container{
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .form-title{
        ul{
            padding: 0;
        }
        font-size: 22px!important;
    }
    .comment-form{
        max-width: 1120px;
        width: 100%;
        margin: auto;
        padding: 0;
        div{
            padding: 0;
        }
    .title{
        width: 100%;
        text-align: right;
        font-size: 30px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #1a1a1a;
    span{
        color: #cc171d;
    }
    }
    }
    button{
        max-width: 369px;
        width: 90%;
        height: 54px;
        margin: auto;
        background-color: #162336;
        color: white;
        border: solid 1px #979797;
        border-radius: 10px;
        transition: 0.1s all;
    }
    button:hover{
        background-color: #fe7063;
        color: white;
    }
</style>